import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

interface MillingEmailState {
  loading: boolean;
  success: boolean;
  error: string | null;
}

const initialState: MillingEmailState = {
  loading: false,
  success: false,
  error: null,
};

export const sendMillingEmail = createAsyncThunk<
  any,
  { file_ids: string[]; sendBy: string },
  { rejectValue: string }
>(
  'milling/sendEmail',
  async ({ file_ids, sendBy }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/auth/admin/milling`,
        {
          file_id: file_ids,
          sendBy,
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || 'Failed to send milling email'
      );
    }
  }
);

export const sendJuMillingEmail = createAsyncThunk<
  any,
  { file_ids: string[]; material?: string; shade?: string },
  { rejectValue: string }
>(
  'milling/sendJuEmail',
  async ({ file_ids, material, shade }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/auth/user/milling`,
        {
          file_id: file_ids,
          material,
          shade,
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || 'Failed to send milling email'
      );
    }
  }
);

const millingEmailSlice = createSlice({
  name: 'millingEmail',
  initialState,
  reducers: {
    resetMillingEmailState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMillingEmail.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendMillingEmail.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendMillingEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(sendJuMillingEmail.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendJuMillingEmail.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendJuMillingEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetMillingEmailState } = millingEmailSlice.actions;
export default millingEmailSlice.reducer;
